export const UpTriangle = ({status}) => {

    let color=status=="normal"?"#4AD395":status=="abnormal"?"#F1BC15":status=="critical"?"#CB2027":"#4AD395"

    return (
        <svg width="10" height="14" viewBox="0 0 66 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33 0L66 56L0 56L33 0Z" fill={color} />
        </svg>


    )
}

export const UpTriangleV2 = ({status}) => {

    let color=status=="normal"?"#4AD395":status=="abnormal"?"#F1BC15":status=="critical"?"#CB2027":"#4AD395"

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
        <path id="Polygon_23" data-name="Polygon 23" d="M6.5,0,13,13H0Z" fill={color}/>
      </svg>
      


    )
}


export const ECGIconV2 = ({status}) => {

    //let color=status=="normal"?"#4AD395":status=="abnormal"?"#F1BC15":status=="critical"?"#CB2027":"#4AD395"

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
        <path id="Polygon_23" data-name="Polygon 23" d="M6.5,0,13,13H0Z" fill="#f1bc15"/>
      </svg>
      


    )
}



export const OptionsIcon = ({color}) => {

  
    return (
        <svg height="15" viewBox="0 0 16 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16ZM8 24C3.6 24 0 27.6 0 32C0 36.4 3.6 40 8 40C12.4 40 16 36.4 16 32C16 27.6 12.4 24 8 24ZM8 48C3.6 48 0 51.6 0 56C0 60.4 3.6 64 8 64C12.4 64 16 60.4 16 56C16 51.6 12.4 48 8 48Z" fill={color?color:"#1C94F9" }/>
        </svg>


    )
}

export const SearchIcon = () => {

  
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18.694" height="18.486" viewBox="0 0 20.694 20.486">
        <g id="Group_165" data-name="Group 165" transform="translate(-426 -243)">
          <g id="Rectangle_103" data-name="Rectangle 103" transform="translate(439.818 255.196) rotate(45)" fill="#fff" stroke="#1d2b39" stroke-width="1">
            <rect width="9.724" height="2" rx="1" stroke="none"/>
            <rect x="0.5" y="0.5" width="8.724" height="1" rx="0.5" fill="none"/>
          </g>
          <g id="Ellipse_80" data-name="Ellipse 80" transform="translate(426 243)" fill="none" stroke="#1d2b39" stroke-width="1.6">
            <circle cx="8" cy="8" r="8" stroke="none"/>
            <circle cx="8" cy="8" r="7.2" fill="none"/>
          </g>
        </g>
      </svg>
      


    )
}

export const BlueArrowDown = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
          <path id="Polygon_14" data-name="Polygon 14" d="M5.5,0,11,11H0Z" transform="translate(11 11) rotate(180)" fill="#0a8ce0" />
      </svg>

  )
}

export const DoubbleBlueArrowDown = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15">
          <g id="Group_49" data-name="Group 49" transform="translate(-495 -600)">
              <path id="Polygon_14" data-name="Polygon 14" d="M3.5,0,7,7H0Z" transform="translate(502 615) rotate(180)" fill="#0a8ce0" />
              <path id="Polygon_17" data-name="Polygon 17" d="M3.5,0,7,7H0Z" transform="translate(495 600)" fill="#0a8ce0" />
          </g>
      </svg>


  )
}